import {catchError, from, map, Observable, switchMap, tap} from 'rxjs';
import {AxiosError, AxiosResponse} from 'axios';
import {setEntities} from '@ngneat/elf-entities';

import {serviceKindsStore} from '@store/settings/serviceKinds/serviceKinds.store';
import {ManageServiceKind, ServiceKindsPagination} from '@store/settings/serviceKinds/serviceKinds.model';
import {getServiceKindDataSource} from '@store/settings/serviceKinds/serviceKinds.requests';

import APIAxios, {APIRoutes} from '@api/axios.api';
import SnackError from '@utils/error.utils';
import {TableConfig} from '@constants/table.constants';

export class ServiceKindsService {
  store = serviceKindsStore;

  resetStore = () => this.store.reset();

  searchServiceKinds = (search?: string): Observable<ServiceKindsPagination> => {
    return from(APIAxios({
      ...APIRoutes.GETServiceKinds(),
      params: {
        searchString: search || undefined,
        page: 1,
        limit: TableConfig.pagination,
      },
    }))
      .pipe(
        catchError((err: AxiosError) => {
          throw new SnackError((err.response as any)?.data?.message, 'error');
        }),
        map((response: AxiosResponse<ServiceKindsPagination>) => {
          return response.data;
        }),
      );
  };

  getServiceKinds = (): Observable<ServiceKindsPagination> => {
    return from(APIAxios({
      ...APIRoutes.GETServiceKinds(),
      params: {disablePaginate: true}
    }))
      .pipe(
        catchError((err: AxiosError) => {
          throw new SnackError((err.response as any)?.data?.message, 'error');
        }),
        map((response: AxiosResponse<ServiceKindsPagination>) => {
          return response.data;
        }),
        tap((serviceKindsPagination) => {
          this.store.update(
            setEntities(serviceKindsPagination.data),
            getServiceKindDataSource.setSuccess(),
          );
        }),
        getServiceKindDataSource.trackRequestStatus(),
      );
  };

  createServiceKind = (data: ManageServiceKind): Observable<ServiceKindsPagination> => {
    return from(APIAxios({
      ...APIRoutes.POSTServiceKind(),
      data,
    }))
      .pipe(
        catchError((err: AxiosError) => {
          throw new SnackError((err.response as any)?.data?.message, 'error');
        }),
        switchMap(() => this.getServiceKinds()),
      );
  };

  updateServiceKind = (serviceKindId: number | string, data: ManageServiceKind): Observable<ServiceKindsPagination> => {
    return from(APIAxios({
      ...APIRoutes.PUTServiceKind(serviceKindId),
      data,
    }))
      .pipe(
        catchError((err: AxiosError) => {
          throw new SnackError((err.response as any)?.data?.message, 'error');
        }),
        switchMap(() => this.getServiceKinds()),
      );
  };

}

export const serviceKindsService = new ServiceKindsService();
